// resources/js/components/LeftPanel/DataPanel/DataPanel.js

import React, { Fragment, useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { Tab, Row, Col, Nav } from "react-bootstrap";

import Style from "./DataPanel.scss";
import GeoDataPanel from "./GeoDataPanel";
import DetailParcelle from "../DetailParcelle/DetailParcelle";
import DetailFiscal from "../DetailParcelle/DetailFiscal";
import RelevePropPanel from "../ReleveProp/RelevePropPanel";
import ValeursFoncieres from "../ValeursFoncieres/ValeursFoncieres";
import FormsList from "./FormsList";

import NonAccess from "../../Layout/NonAccess";
import GeoDataParcelle from "./geodata/GeoDataParcelle";
import axios from "axios";

const DataPanel = (props) => {
   // Determine the initial tab based on subscription.
   // If subscription is null, default to "formulairesShow", otherwise use "dvf".
   const initialTab = props.subscription === null ? "formulairesShow" : "dvf";
   const [currentTab, setCurrentTab] = useState(initialTab);
   const [detaillData, setDetailData] = useState(true);
   const [showToggleDetail, detShowToggleDetail] = useState(false);
   const [isLoading, setIsLoading] = useState(false);
   const winHeight = window.innerHeight;

   // Ref to track previous parcelles length
   const prevParcellesLength = useRef(props.currentParcelles.length);

   useEffect(() => {
      fetchUserAccessRight();
   }, []);

   useEffect(() => {
      if (props.showCurrentTab) {
         setCurrentTab(props.showCurrentTab);
      }
   }, [props.showCurrentTab]);

   // Only on mount, set the default tab to "formulairesShow" if no subscription.
   useEffect(() => {
      if (props.subscription === null && props.showCurrentTab !== "formulairesShow") {
         props.toggleCurrentTab("formulairesShow");
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   const handleChangeDetail = () => {
      setDetailData(!detaillData);
      props.showDetailData(!detaillData);
   };

   const handleClosePanel = () => {
      props.setLeftPanelOpen(false);
      props.showCurrentSection("map");
   };

   // Open the panel when parcelles are selected
   useEffect(() => {
      props.resetFeatures();
      if (props.currentParcelles.length > 0) {
         props.setLeftPanelOpen(true);
      }
   }, [props.currentParcelles, props]);

   // Close the panel only when parcelles go from non-empty to empty
   useEffect(() => {
      if (prevParcellesLength.current > 0 && props.currentParcelles.length === 0) {
         handleClosePanel();
      }
      prevParcellesLength.current = props.currentParcelles.length;
   }, [props.currentParcelles]);

   const fetchUserAccessRight = async () => {
      try {
         let result = await axios.post("/Api/user/accesslevel", {});
         if (result.data) {
            props.updateUserAccesLevel(result.data.result);
         }
      } catch (error) {
         console.error("Erreur lors de la récupération du niveau d'accès utilisateur :", error);
      }
   };

   return (
      <div className={"ue-data-panel"}>
         <Tab.Container
            id="panel_tabs"
            // defaultActiveKey isn't used in controlled components, but it's here for clarity.
            defaultActiveKey={props.subscription === null ? "formulairesShow" : "geoData"}
            activeKey={props.showCurrentTab}
         >
            {props.showCurrentTab !== "detailParcelle" && props.showCurrentTab !== "detailFiscale" ? (
               <Row className={"mb-3 d-none d-md-block"}>
                  <Col>
                     <Nav variant="tabs" fill>
                        <Nav.Item
                           data-testid={"navtab"}
                           style={{
                              backgroundColor:
                                 props.showCurrentTab === "geoData"
                                    ? "var(--theme-page-background)"
                                    : "var(--theme-page-background-alternate)",
                           }}
                        >
                           <Nav.Link
                              data-testid={"navtab-info"}
                              style={{
                                 paddingLeft: "70px",
                                 paddingRight: "70px",
                                 fontWeight: "700",
                              }}
                              eventKey="geoData"
                              onSelect={() => props.toggleCurrentTab("geoData")}
                           >
                              INFO PARCELLE{" "}
                           </Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                           style={{
                              backgroundColor:
                                 props.showCurrentTab === "formulairesShow"
                                    ? "var(--theme-page-background)"
                                    : "var(--theme-page-background-alternate)",
                           }}
                        >
                           <Nav.Link
                              style={{
                                 paddingLeft: "80px",
                                 fontWeight: "700",
                              }}
                              data-testid={"navtab-formslist"}
                              eventKey="formulairesShow"
                              onSelect={() => props.toggleCurrentTab("formulairesShow")}
                           >
                              FORMULAIRE
                           </Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                           style={{
                              backgroundColor:
                                 props.showCurrentTab === "formulairesShow"
                                    ? "var(--theme-page-background)"
                                    : "var(--theme-page-background-alternate)",
                           }}
                        >
                           <Nav.Link
                              eventKey="close"
                              onSelect={handleClosePanel}
                              className={"ue-navdata-close"}
                           >
                              <svg
                                 width="10"
                                 height="10"
                                 viewBox="0 0 6 6"
                                 fill="none"
                                 xmlns="http://www.w3.org/2000/svg"
                              >
                                 <path
                                    d="M5.91659 0.670844L5.32909 0.0833435L2.99992 2.41251L0.670752 0.0833435L0.083252 0.670844L2.41242 3.00001L0.083252 5.32918L0.670752 5.91668L2.99992 3.58751L5.32909 5.91668L5.91659 5.32918L3.58742 3.00001L5.91659 0.670844Z"
                                    fill="#F2F2F2"
                                 />
                              </svg>
                           </Nav.Link>
                        </Nav.Item>
                     </Nav>
                  </Col>
               </Row>
            ) : null}
            <div className="data-panel-scrollable px-2">
               <div className={"d-flex flex-column px-2"}>
                  <div style={{ userSelect: "none", paddingBottom: "5px" }}>
                     {props.currentParcelles.length > 0 ? (
                        <Fragment>
                           {props.showCurrentTab !== "detailParcelle" && props.showCurrentTab !== "detailFiscale" ? (
                              <GeoDataParcelle keypars={props.currentParcelles} />
                           ) : null}
                        </Fragment>
                     ) : (
                        <div className={"d-flex flex-column flex-center justify-content-center align-content-center"}>
                           <div
                              className={"card"}
                              style={{
                                 backgroundColor: "var(--theme-page-color)",
                              }}
                           >
                              <div className={"card-body text-center"}>
                                 <h1 className={"text-danger"}>
                                    <i className="bi bi-exclamation-diamond"></i>
                                 </h1>
                                 <h4 className={"p-2 font-weight-light"}>
                                    Merci de sélectionner une parcelle <br />
                                    afin d'afficher les données correspondantes
                                 </h4>
                              </div>
                           </div>
                        </div>
                     )}
                  </div>
               </div>
               <Row className={"px-2"}>
                  <Col>
                     <Tab.Content>
                        <Tab.Pane
                           eventKey="geoData"
                           title="Données"
                           onSelect={() => setCurrentTab("geoData")}
                        >
                           <GeoDataPanel />
                        </Tab.Pane>
                        <Tab.Pane
                           eventKey="formulairesShow"
                           title="forms"
                           onSelect={() => setCurrentTab("formulairesShow")}
                        >
                           <FormsList />
                        </Tab.Pane>
                        <Tab.Pane
                           eventKey="detailParcelle"
                           title="Données à la parcelle"
                           onSelect={() => setCurrentTab("detailParcelle")}
                        >
                           <DetailParcelle />
                        </Tab.Pane>
                        <Tab.Pane
                           eventKey="detailFiscale"
                           title="Données fiscales"
                           onSelect={() => setCurrentTab("detailFiscale")}
                        >
                           <DetailFiscal />
                        </Tab.Pane>
                        <Tab.Pane eventKey="releve_prop" title="Relevé de propriété">
                           {props?.entity?.genre?.slug === "collective" ? <RelevePropPanel /> : <NonAccess />}
                        </Tab.Pane>
                        <Tab.Pane eventKey="dvf" title="Valeurs foncières">
                           {props?.entity?.genre?.slug === "collective" ? <ValeursFoncieres /> : <NonAccess />}
                        </Tab.Pane>
                     </Tab.Content>
                  </Col>
               </Row>
            </div>
         </Tab.Container>
      </div>
   );
};

const mapStateToProps = (state) => {
   return {
      entity: state.MeReducer.entity,
      show_stack: state.LayersReducer.show_stack,
      show_detail_parcelle: state.LeftPanelReducer.showDetailParcelle,
      subscription: state.MeReducer.subscription,
      showCurrentTab: state.LeftPanelReducer.showCurrentTab,
      currentParcelles: state.MapReducer.currentParcelle,
      windowsSize: state.AppReducer.windowsSize,
   };
};

const mapDispatchToProps = (dispatch) => {
   return {
      showDataPanel: (e) => dispatch({ type: "SHOW_FLOATING_DATA_PANEL", data: e }),
      showCurrentSection: (e) => dispatch({ type: "SHOW_CURRENT_SECTION", data: e }),
      setLeftPanelWidth: (e) => dispatch({ type: "SET_LEFT_PANEL_WIDTH", data: e }),
      setLeftPanelOpen: (e) => dispatch({ type: "SET_LEFT_PANEL_OPEN", data: e }),
      showDetailData: (e) => dispatch({ type: "SHOW_DETAIL_PANEL_DATA", data: e }),
      toggleCurrentTab: (e) => dispatch({ type: "TOGGLE_PANEL_TAB", data: { currentTab: e } }),
      setTotalCoundDataRef: (e) => dispatch({ type: "SET_COUNT_TOTAL-DATA_REF", data: e }),
      resetListDataRef: (e) => dispatch({ type: "RESET_LIST_DATA_REF" }),
      updateUserAccesLevel: (e) => dispatch({ type: "UPDATE_USER_ACCESS_LEVEL", data: e }),
      resetFeatures:(e) => dispatch({type: "RESET_VECTOR_REMOVE_FEATURE"}),
   };
};

export default connect(mapStateToProps, mapDispatchToProps)(DataPanel);
